var map = {
	"./2.png": 104,
	"./3.png": 325,
	"./Blog1.jpeg": 326,
	"./Blog2.jpeg": 327,
	"./Blog4.jpeg": 328,
	"./BlogBanner.jpeg": 161,
	"./benefitsofdrone.png": 154,
	"./cost.png": 156,
	"./drone.jpg": 153,
	"./farmersafety.png": 157,
	"./farming.png": 159,
	"./fs-logo-2.jpg": 329,
	"./fs-logo.png": 330,
	"./fs-logo.svg": 331,
	"./logo.png": 332,
	"./logo.svg": 98,
	"./soil.png": 155,
	"./water.png": 158,
	"./whatwedo.png": 97
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;